import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './style.css';

const propTypes = {
  id: PropTypes.string,
  children: PropTypes.node,
  tooltip: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.string,
    PropTypes.array,
  ]),
  classes: PropTypes.object,
  className: PropTypes.string,
  direction: PropTypes.string,
  enableTableTip: PropTypes.bool,
  style: PropTypes.shape({
    top: PropTypes.string,
    right: PropTypes.string,
    bottom: PropTypes.string,
    left: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    whiteSpace: PropTypes.string,
  }),
  isWhiteBack: PropTypes.bool,
};

// 方位提供:
// bottom,bottomLeft,bottomRight,
// top,topLeft,topRight,
// left,right

const defaultProps = {
  direction: 'bottom',
};

const Tooltip = (props) => {
  const {
    id,
    children,
    tooltip,
    className,
    direction,
    isWhiteBack = false, // 原先樣式為黑底白字，可以設定此選項更改樣式為白底黑字
    style, // 版型已經設定好，只需調整top,right,bottom,left,width,height,whiteSpace就好
  } = props;
  return (
    <div className="tooltip-container">
      {children}
      <div
        id={id}
        className={cx('tooltip', `${direction}`, `${className}`, {
          'white': isWhiteBack,
        })}
        style={style}
      >
        {Array.isArray(tooltip)
          ? tooltip.map((item, i) => <div key={i}>{item}</div>)
          : tooltip}
      </div>
    </div>
  );
};

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;

export default Tooltip;



/** WEBPACK FOOTER **
 ** D:/a/1/s/src/componentsv3/Tooltip/index.js
 **/